import { createContext, useEffect, useState } from "react";
import Preloader from "../preloader";
import { ErrorToastContainer, SuccessToastContainer } from "../../function/CustomFunction";
import { getToken } from "../../function/token";
import Payment from "./payment";
import domain from "../../../reusecomponent/domain";
import "./paymenthistory.css";

export const DateContext = createContext();

export default function Paymenthistory({product}) {
  // All hooks must be called at the top level
  const [loder,setloder] = useState(false);
  const [payments,setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [time,setTime] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateFilter, setDateFilter] = useState('all');
  const [amountFilter, setAmountFilter] = useState('all');

  useEffect(()=>{
    const now = new Date();
    now.setMinutes(now.getMinutes() - 8);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const date = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    
    let t = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
    setTime(t);

    setloder(true);
    const myHeaders = new Headers();
    const access_token = getToken();
    myHeaders.append("Authorization", `Bearer ${access_token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    fetch(`${domain()}/payment-history/${product}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setloder(false);
        if(result.status){
          setPayments(result.data);
          setFilteredPayments(result.data);
          SuccessToastContainer(result.message);
        }else{
          ErrorToastContainer(result.message);
        }          
      })
      .catch((error) => {
        setloder(false);
        ErrorToastContainer('Internal Server Error');
    });
  },[]);

  // Filter payments based on search criteria
  useEffect(() => {
    let filtered = [...payments];

    // Search term filter
    if (searchTerm) {
      filtered = filtered.filter(payment => 
        payment.order_id?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.utr_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.message?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.total_amount?.toString().includes(searchTerm)
      );
    }

    // Status filter
    if (statusFilter !== 'all') {
      filtered = filtered.filter(payment => {
        const paymentStatus = payment.status;
        const filterStatusInt = parseInt(statusFilter);
        
        // Handle pending status (can be 2, null, undefined, or empty string)
        if (filterStatusInt === 2) {
          return paymentStatus === 2 || paymentStatus === '2' || 
                 paymentStatus === null || paymentStatus === undefined || 
                 paymentStatus === '';
        }
        
        // Handle success (1) and failed (0) status
        return parseInt(paymentStatus) === filterStatusInt;
      });
    }



    // Date filter
    if (dateFilter !== 'all') {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const lastWeek = new Date(today);
      lastWeek.setDate(lastWeek.getDate() - 7);
      const lastMonth = new Date(today);
      lastMonth.setMonth(lastMonth.getMonth() - 1);

      filtered = filtered.filter(payment => {
        const paymentDate = new Date(`${payment.date} ${payment.time}`);
        
        switch (dateFilter) {
          case 'today':
            return paymentDate.toDateString() === today.toDateString();
          case 'yesterday':
            return paymentDate.toDateString() === yesterday.toDateString();
          case 'last7days':
            return paymentDate >= lastWeek;
          case 'last30days':
            return paymentDate >= lastMonth;
          default:
            return true;
        }
      });
    }

    // Amount filter
    if (amountFilter !== 'all') {
      filtered = filtered.filter(payment => {
        const amount = parseFloat(payment.total_amount);
        
        switch (amountFilter) {
          case '0-1000':
            return amount >= 0 && amount <= 1000;
          case '1000-5000':
            return amount > 1000 && amount <= 5000;
          case '5000-10000':
            return amount > 5000 && amount <= 10000;
          case '10000+':
            return amount > 10000;
          default:
            return true;
        }
      });
    }

    setFilteredPayments(filtered);
  }, [payments, searchTerm, statusFilter, dateFilter, amountFilter]);

  // Clear all filters
  const clearFilters = () => {
    setSearchTerm('');
    setStatusFilter('all');
    setDateFilter('all');
    setAmountFilter('all');
  };

  // Get active filters count
  const getActiveFiltersCount = () => {
    let count = 0;
    if (searchTerm) count++;
    if (statusFilter !== 'all') count++;
    if (dateFilter !== 'all') count++;
    if (amountFilter !== 'all') count++;
    return count;
  };

  // Check if user has permission to view payment history
  // if (!hasPermission(PERMISSIONS.BILLING_PAYMENT_HISTORY_VIEW)) {
  //   return (
  //     <div className="container-fluid">
  //       <div className="row justify-content-center">
  //         <div className="col-12 text-center mt-5">
  //           <h3>Access Denied</h3>
  //           <p>You don't have permission to view payment history.</p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  
  return (
    <DateContext.Provider value={time}>
      <div className="container-fluid dashboard-main m-0 py-0">
        <Preloader action={loder}/>
        
        {/* Header Section */}
        <div className="payment-history-header py-1 px-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h4 className="payment-history-title">
                Payment History
              </h4>
              <p className="payment-history-subtitle">
                Track all your payment transactions and invoices
              </p>
            </div>
            <div className="payment-stats">
              <div className="payment-stat-badge payment-stat-success">
                <i className="fas fa-check-circle"></i>
                {payments.filter(p => parseInt(p.status) === 1).length} Successful
              </div>
              <div className="payment-stat-badge payment-stat-pending">
                <i className="fas fa-clock"></i>
                {payments.filter(p => parseInt(p.status) === 2).length} Pending
              </div>
            </div>
          </div>
        </div>
        
        {/* Filters Section */}
        <div className="payment-filters-section p-0 py-2">
          <div className="payment-filters-grid">
            {/* Search Input */}
            <div className="payment-search-container">
              <input
                type="text"
                className="payment-search-input"
                placeholder="Search by Order ID, UTR, Amount, or Message..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <i className="fas fa-search payment-search-icon"></i>
            </div>

            {/* Status Filter */}
            <select
              className="payment-filter-select h-100"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All Status</option>
              <option value="1">Success</option>
              <option value="2">Pending</option>
              <option value="0">Failed</option>
            </select>

            {/* Date Filter */}
            <select
              className="payment-filter-select h-100"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            >
              <option value="all">All Time</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="last7days">Last 7 Days</option>
              <option value="last30days">Last 30 Days</option>
            </select>

            {/* Amount Filter */}
            <select
              className="payment-filter-select h-100"
              value={amountFilter}
              onChange={(e) => setAmountFilter(e.target.value)}
            >
              <option value="all">All Amounts</option>
              <option value="0-1000">₹0 - ₹1,000</option>
              <option value="1000-5000">₹1,000 - ₹5,000</option>
              <option value="5000-10000">₹5,000 - ₹10,000</option>
              <option value="10000+">₹10,000+</option>
            </select>

            {/* Clear Filters Button */}
            <button
              className="payment-clear-btn"
              onClick={clearFilters}
              disabled={getActiveFiltersCount() === 0}
            >
              <i className="fas fa-times me-1"></i>
              Clear
            </button>
          </div>

          {/* Results Summary */}
          <div className="payment-results-summary px-3">
            <div>
              Showing {filteredPayments.length} of {payments.length} payments
              {getActiveFiltersCount() > 0 && (
                <span className="ms-2">
                  <span className="payment-filter-count">
                    {getActiveFiltersCount()} filter{getActiveFiltersCount() > 1 ? 's' : ''} active
                  </span>
                </span>
              )}
            </div>
            {filteredPayments.length !== payments.length && (
              <button
                className="payment-show-all-btn"
                onClick={clearFilters}
              >
                Show All Results
              </button>
            )}
          </div>
        </div>
        
        {/* Table Section */}
        <div className="payment-table-container">
          <table className="payment-history-table">
            <thead>
              <tr>
                <th className="py-2">Order ID</th>
                <th className="py-2">Amount</th>
                <th className="py-2">Payment Type</th>
                <th className="py-2">UTR Number</th>
                <th className="py-2 text-center">Status</th>
                <th className="py-2">Message</th>
                <th className="py-2">Date & Time</th>
                <th className="py-2 text-center">Invoice</th>
              </tr>
            </thead>
            <tbody>
              {filteredPayments.length > 0 ? (
                filteredPayments.map((payment) => (
                  <Payment key={payment.order_id} payment={payment} setloder={setloder}/>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="payment-empty-state p-0">
                    <div className="d-flex flex-column align-items-center">
                      <div className="payment-empty-icon">
                        <i className="fas fa-search"></i>
                      </div>
                      <h5 className="payment-empty-title">
                        {payments.length > 0 ? 'No Results Found' : 'No Payment Records Found'}
                      </h5>
                      <p className="payment-empty-message">
                        {payments.length > 0 
                          ? 'Try adjusting your search criteria or filters'
                          : 'Your payment history will appear here once you make transactions'
                        }
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DateContext.Provider>
  );
}
